import { gql } from "@apollo/client";

// `Profile` does not expose the verification date; the user record does, and
// `user(userId)` resolves for the caller's own id regardless of role.
export const UserEmailVerification = gql`
    query UserEmailVerification($userId: ID!) {
        user(userId: $userId) {
            id
            emailVerifiedAt
        }
    }
`;
